import { Label } from "@tandemdiabetes/sugarmate-react-components"
import styles from "./AccountDetails.module.scss"

type Props = {
  title: string;
  content: string;
  id: string;
}

export function ViewableDetails(props: Props) {
  const {
    title, content, id,
  } = props

  return (
    <div id={id}>
      <Label className={styles.viewableLabel}>
        {title}
      </Label>
      <div className={styles.viewableDetails}>
        {content}
      </div>
    </div>
  )
}
